export const environment = {
  appName: 'SITT-Partnerportal',
  production: true,
  api: 'https://api.' + location.hostname,
  sentry: {
    dsn: 'https://69fe7d4f957fe46550a1c4911aa1e3a3@o4505765778292736.ingest.us.sentry.io/4507153036476416',
  },
};
